import React from 'react';
import { Switch, Route } from 'react-router';
import { RouteComponentProps } from '~/App/shared/interfaces/routes';
import { RouteConfig } from '~/config/routes/types';
import SwedishDomainOnlyGuard from '~/config/routes/SwedishDomainOnlyGuard';

export const renderRoutes = (
  routes?: RouteConfig[],
  extraProps: Record<string, unknown> = {}
) => {
  return routes ? (
    <Switch>
      {routes.map((route, i) => (
        <Route
          key={route.key || i}
          path={route.path}
          exact={route.exact}
          strict={route.strict}
          render={(props: RouteComponentProps) => (
            <SwedishDomainOnlyGuard
              route={route}
              location={props.location}
              staticContext={props.staticContext}
            >
              {route.render
                ? route.render({ ...props, ...extraProps, route: route })
                : route.component && (
                    <route.component {...props} {...extraProps} route={route} />
                  )}
            </SwedishDomainOnlyGuard>
          )}
        />
      ))}
    </Switch>
  ) : null;
};
